<template>
  <span>{{ displayValue.toLocaleString() }}</span>
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    value: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      default: 1000
    },
    format: {
      type: Boolean,
      default: true
    },
    easing: {
      type: String,
      default: 'linear',
      validator: (value) => ['linear', 'easeIn', 'easeOut', 'easeInOut'].includes(value)
    }
  },
  data() {
    return {
      displayValue: 0,
      interval: null
    }
  },
  mounted() {
    this.animateValue(this.value);
  },
  watch: {
    value(newVal) {
      this.animateValue(newVal);
    }
  },
  methods: {
    animateValue(newVal) {
      // Make sure we have a valid number
      if (typeof newVal !== 'number' || isNaN(newVal)) {
        console.error('Invalid value provided to AnimatedNumber:', newVal);
        this.displayValue = 0;
        return;
      }
      
      clearInterval(this.interval);
      const startVal = this.displayValue;
      const endVal = newVal;
      const diff = endVal - startVal;
      const startTime = performance.now();
      
      this.interval = setInterval(() => {
        const currentTime = performance.now();
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / this.duration, 1);
        
        // Apply easing
        let easedProgress = progress;
        switch (this.easing) {
          case 'easeIn':
            easedProgress = progress * progress;
            break;
          case 'easeOut':
            easedProgress = 1 - Math.pow(1 - progress, 2);
            break;
          case 'easeInOut':
            easedProgress = progress < 0.5
              ? 2 * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            break;
          default: // linear
            easedProgress = progress;
        }
        
        if (progress >= 1) {
          this.displayValue = endVal;
          clearInterval(this.interval);
        } else {
          this.displayValue = Math.round(startVal + diff * easedProgress);
        }
      }, 16); // ~60fps
    }
  },
  beforeUnmount() {
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
/* Optional: Add a subtle highlight effect */
@keyframes highlight {
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
}
</style>
